import React, { FC, useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import * as S from './styles'
import { Typography, useDimensions } from '@telavita-core/react-design-kit'

interface UploadProps {
  onUpload: (files: File[]) => void;
  error?: string;
}

const Upload: FC<UploadProps> = (props) => {
  const { onUpload, error } = props
  const { isMobile } = useDimensions()
  const [errorUpload, setErrorUpload] = useState(error)

  const handleUpload = (files: File[]) => {
    setErrorUpload('')
    onUpload(files)
  }

  const { getRootProps, getInputProps, fileRejections } = useDropzone({
    onDrop: handleUpload,
    accept: {
      'image/jpeg': ['.jpg', '.jpeg', '.png', '.svg', '.webp'],
      'text/plain': ['.txt', 'csv'],
      'application/msword': ['.doc'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
        '.docx',
      ],
      'application/pdf': ['.pdf'],
    },
  })

  useEffect(() => {
    fileRejections.forEach(({ errors }) => {
      const hasErrorTypeFile = errors.findIndex(
        (error) => error.code === 'file-invalid-type'
      )

      if (hasErrorTypeFile >= 0) {
        setErrorUpload(
          'O formato de arquivo é inválido. São aceitos apenas arquivos de texto ou imagem. Tente novamente.'
        )
      }
    })
  }, [fileRejections])

  useEffect(() => {
    setErrorUpload(error)
  }, [error])

  return (
    <S.UploadContainer {...getRootProps()}>
      <input {...getInputProps()} />
      <S.Content>
        {errorUpload && (
          <S.ErrorText>
            <Typography variant="content2">{errorUpload}</Typography>
          </S.ErrorText>
        )}
        {!isMobile && (
          <>
            <S.InstructionsText>
              <Typography variant="content2">
                Arraste os arquivos para cá
              </Typography>
            </S.InstructionsText>
            <S.InstructionsText>
              <Typography variant="content2">ou</Typography>
            </S.InstructionsText>
          </>
        )}
        <S.CustomButton>
          {!isMobile ? 'Selecione do seu dispositivo' : 'Anexar um arquivo'}
        </S.CustomButton>
        <S.LimitSizeText>
          <Typography variant="content3">
            Tamanho máximo de upload: <b>20 MB.</b>
          </Typography>
        </S.LimitSizeText>
      </S.Content>
    </S.UploadContainer>
  )
}
export default Upload
